import React, { useEffect, useState } from 'react';
import { LucidLoader } from '../icons';

const MetaDataCncComponent = ({ item, allData }) => {
    const [resolvedMeta, setResolvedMeta] = useState({
        material: '',
        grade: '',
        finish: '',
        treatment: '',
        tolerance: '',
        marking: '',
        internalCorner: '',
    });

    useEffect(() => {
        if (!item || !allData) return;

        const materialObj = allData?.cncMaterialData?.find(val => val._id === item.cncMaterial);
        const finishObj = allData?.cncSurfaceFinishData?.find(val => val._id === item.cncSurfaceFinish);
        const treatmentObj = allData?.cncHeatTreatmentData?.find(val => val._id === item.cncHeatTreatment);
        const toleranceObj = allData?.cncToleranceData?.find(val => val._id === item.cncTolerance);
        const markingObj = allData?.cncPartMarkingData?.find(val => val._id === item.cncPartMarking);
        const internalCornerObj = allData?.cncInternalCornerData?.find(val => val._id === item.cncInternalCorner);

        setResolvedMeta({
            material: materialObj?.cnc_material || '',
            grade: materialObj?.cnc_grade || '',
            finish: finishObj?.cnc_surface_finish || '',
            treatment: treatmentObj?.cnc_heat_treatment || '',
            tolerance: toleranceObj?.cnc_tolerance || '',
            marking: markingObj ? 'Yes' : 'No',
            internalCorner: internalCornerObj?.cnc_internal_corner || '',
        });
    }, [item, allData]);

    const renderRow = (label, value) => (
        value ? (
            <span title={value} className="flex text-sm gap-x-1 space-y-0    text-gray-800">
                <span className="min-w-[100px]">{label}:</span>
                <span className="truncate">{value}</span>
            </span>
        ) : null
    );


    const isLoading = !resolvedMeta.material;

    return (
        <div className="w-full max-w-md px-2">
            {isLoading ? (
                <div className="flex items-center justify-center h-24 text-primaryColor">
                    <LucidLoader />
                </div>
            ) : (
                <div className="flex flex-col -space-y-1">
                    {renderRow('Material', resolvedMeta.material)}
                    {renderRow('Grade', resolvedMeta.grade)}
                    {renderRow('Finish', resolvedMeta.finish)}
                    {renderRow('Treatment', resolvedMeta.treatment)}
                    {renderRow('Tolerance', resolvedMeta.tolerance)}
                    {renderRow('Marking', resolvedMeta.marking)}
                    {renderRow('Internal corner', resolvedMeta.internalCorner)}
                </div>
            )}
        </div>
    );

};

export default MetaDataCncComponent;
